export const GOOD_PUP_PRIVACY_LINK = 'https://goodpup.com/privacy';
export const GOOD_PUP_TERMS_LINK = 'https://goodpup.com/tos';
export const GOOD_PUP_FREE_TRIAL_LINK = 'https://links.goodpup.com/dog-services/rover20';
export const EMBEDDED_GOODPUP_LINK = 'https://goodpup.com/redirect/rover-1';
export const GOODPUP_LINK = 'https://links.goodpup.com/zHX08HnzKqb';
